import { useSiteMetadata, useColorMode } from "@reflexjs/gatsby-theme-core";
import Logo from "../../../../content/assets/logo_prairial.inline.svg";
import * as React from 'react';
export default {
  useSiteMetadata,
  useColorMode,
  Logo,
  React
};